module.exports = __webpack_public_path__ + "media/dang-kee-yes.14b45cb4.mp3";